<template>
  <multiselect
      id="dashboardDeviceColumns"
      v-model="selectedOptions"
      @update:modelValue="onSelectOptions"
      :options="dashboardDeviceColumns"
      :placeholder="$t('settings.generic.select-items')"
      label="translationKey" track-by="value"
      class="tracking-multiselect fit-content"
      :multiple="true"
      :close-on-select="false"
      :clear-on-select="false"
      :preserve-search="true"
      :show-labels="false"
      :show-no-results="false"
      :show-no-options="false"
  >
    <template #option="props">
      <div class="tracking-multiselect-with-checkbox">
        <input type="checkbox" :checked="isOptionChecked(props.option.value)" @focus.prevent :key="props.option.value" />
        <span class="option__title">{{ $t(props.option.translationKey) }}</span>
      </div>
    </template>
    <template #selection="{ values, isOpen }">
      <span class="multiselect__single" v-if="values.length" v-show="!isOpen">
        {{ $t('settings.generic.selected-items') }} {{ values.length }}
      </span>
    </template>
    <template #placeholder>
      <span>
        {{ $t('settings.generic.select-placeholder') }}
      </span>
    </template>
  </multiselect>
</template>

<script>
import {DashboardDeviceColumn} from "@/assets/js/enums/DashboardDeviceColumn.js";
import Multiselect from "vue-multiselect";

export default {
  name: "ChooseDashboardDeviceColumn",
  components: {Multiselect},
  props: {
    modelValue: {
      type: Array,
      required: true,
      default() { return []; }
    }
  },
  data() {
    return {
      dashboardDeviceColumns: DashboardDeviceColumn.all(),
      selectedOptions: this.modelValue,
    }
  },
  watch: {
    modelValue(values) {
      const selectedOptions = values.map(value => DashboardDeviceColumn.get(value));
      this.onSelectOptions(selectedOptions, false);
    },
  },
  methods: {
    isOptionChecked(value) {
      return this.selectedOptions?.some(x => x.value === value);
    },
    onSelectOptions(data, triggerValueUpdate = true) {
      this.selectedOptions = data;
      if (triggerValueUpdate) {
        this.$emit('update:modelValue', this.selectedOptions.map(x => x.value));
      }
    },
  }
}
</script>

<style scoped lang="scss">

</style>